import { useState, useRef } from 'react'

import {
  Accordion,
  AccordionIcon,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  Center,
  Spinner,
  Stack,
  Text,
  Image
} from '@chakra-ui/react'

import { PAYMENT_RECIPIENTS } from '../../../../lib/paymentRecipients'

import StyledInput from '../../../styled/input'
import StyledTextarea from '../../../styled/text-area'
import StyledNumberInput from '../../../styled/number-input'
import StyledModalButtons from '../../../styled/modal-buttons'
import { useRanContext } from '../../../ran-state-provider'

import { createTicket, uploadImageToImgBB } from '../../../../lib/api-helper'

import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../../../../lib/api-config'

const CreateTicket = ({ onClose, setToast }) => {
  const SERVER = process.env.REACT_APP_SERVER_NAME|| 'STRIFE'
  const RECIPIENT = PAYMENT_RECIPIENTS[SERVER] || PAYMENT_RECIPIENTS.HAVOC
  const { setAuthentication } = useRanContext()
  const [isLoading, setLoading] = useState(false)
  const [agreeTerms, setAgreeTerms] = useState(false)
  const [inputVal, setInputVal] = useState({
    amount: 0,
    message: '',
    file: '',
    fileName: '',
    referenceNumber: ''
  })

  const recaptchaRef = useRef(null);

  const inputIsPass = () => {
    const { amount, message, referenceNumber, file } = inputVal

    const testAmount = !amount || amount < 100
    if (!file)
      setToast({
        status: 'error',
        messages: ['Proof of transaction is required']
      })
    else if (testAmount)
      setToast({ status: 'error', messages: ['Amount >= 100 is required'] })
    else if (!referenceNumber)
      setToast({ status: 'error', messages: ['Reference Number is required'] })
    else if (!message)
      setToast({ status: 'error', messages: ['Message is required'] })
     else if (!agreeTerms)
      setToast({ status: 'error', messages: ['You must agree to the Terms and Conditions'] })

    if (testAmount || !message || !referenceNumber || !file || !agreeTerms) return false
    else return true
  }

  const handleSubmit = async () => {
    if (isLoading) return
    if (inputIsPass()) setLoading(true)
    else return setLoading(false)

    const image = await uploadImageToImgBB(inputVal);

    const onError = () => {
      setToast({
        status: 'error',
        messages: result.errors.length
          ? result.errors
          : ['Something went wrong']
      })
      setLoading(false)
    }

   if (image === null) {
    inputVal.fileName = "not uploaded";
    setToast({
        status: 'warning',
        messages: ['Image upload failed. Ticket will be submitted without image.']
    });
    } else {
        inputVal.fileName = image;
    }

    const captchaToken = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();

    const payload = {
        ...inputVal,
        captchaToken
    };
    
    const result = await createTicket(payload, setAuthentication)

    if (result !== null || result !== undefined) {
      if (result.success) {
        setToast({
          status: 'success',
          messages: ['Ticket has been successfully created!']
        })
        onClose()
      } else onError()
    } else onError()
      

    // if (image !== null) {
    // } else {
    //   setToast({ status: 'error', messages: ['Image file upload failed'] })
    //   setLoading(false)
    // }
  }

  return (
    <>
      {isLoading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        <>
          <Accordion w="full" allowToggle mb={3} outline="1px solid black">
            <AccordionItem>
              <AccordionButton>
                <Box as="span" flex={1} textAlign="left">
                  <b>Click here to view recipient details</b>
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel align="center">
                <b>
                  "{PAYMENT_RECIPIENTS.rules.disclaimer}"
                </b>{' '}
                <br />
                <b>
                  <i>{PAYMENT_RECIPIENTS.rules.rate}</i>
                </b>{' '}
                <br />
                <b>MINIMUM AMOUNT IS {PAYMENT_RECIPIENTS.rules.minAmount} PHP</b> <br />
                <br />
                <b>
                  NO NEED TO INDICATE A MESSAGE WHEN SENDING YOUR PAYMENT.
                </b>{' '}
                <br />
                <br />
                  <Text
                  fontWeight="bold"
                  color="blue.500"
                  mt={2}
                >
                  {RECIPIENT.gcash.title}
                </Text>
             {RECIPIENT.gcash.recipients
            .filter(r => !r.accountLimit) // only show accounts with accountLimit = false
            .map((r, index) => (
                  <Box key={index} mt={2}>
                    ACCOUNT NUMBER #{index + 1}: <b>{r.number}</b>
                    <br />
                    ACCOUNT NAME #{index + 1}: <b>{r.name}</b>
                  </Box>
                ))}
             
                <br />

                  <Image
                  src={RECIPIENT.gcash.qrImage}  // change path if needed
                  alt="GCash QR"
                  mt={2}
                  maxW="200px"
                  mx="auto"
                  borderRadius="md"
                />
      
                <br />
                  <Text
                  fontWeight="bold"
                  color="green.500"
                  mt={2}
                >
                  {RECIPIENT.maya.title}
                </Text>
                ACCOUNT NUMBER: <b>{RECIPIENT.maya.number}</b> <br />
                ACCOUNT NAME : <b>{RECIPIENT.maya.name}</b>
                <br />
               
                 <Text
                  fontWeight="bold"
                  color="pink.500"
                  mt={2}
                >
                  {RECIPIENT.paypal.title}
                </Text>
                EMAIL: <b>{RECIPIENT.paypal.email}</b>
                <br />
                
              </AccordionPanel>
            </AccordionItem>
          </Accordion>

          <Stack spacing={3} w="full">
            <Box bg="#0e0e0e25" py={2} px="28px">
              <Text fontSize={12} color="#22222298" letterSpacing={3}>
                PROOF OF TRANSACTION
              </Text>

              <input
                type="file"
                accept="image/*"
                onChange={e => {
                  setInputVal({ ...inputVal, file: e.target.files[0] })
                }}
              />
            </Box>

            <StyledNumberInput
              placeholder="AMOUNT"
              value={!inputVal.amount ? 'AMOUNT' : inputVal.amount}
              min={0}
              onChange={e =>
                setInputVal({ ...inputVal, amount: parseFloat(e) })
              }
            />

            <StyledInput
              value={inputVal?.referenceNumber}
              onChange={e =>
                setInputVal({ ...inputVal, referenceNumber: e.target.value })
              }
              name="file"
              placeholder="REFERENCE NUMBER"
            />

            <StyledTextarea
              value={inputVal?.message}
              onChange={e =>
                setInputVal({ ...inputVal, message: e.target.value })
              }
              placeholder="MESSAGE OR REFERRAL CODE"
              type="password"
            />


               {/* Terms and Conditions Checkbox */}
           <Stack direction="row" align="center" mt={3}>
            <input
              type="checkbox"
              id="agreeTerms"
              checked={agreeTerms}
              onChange={(e) => setAgreeTerms(e.target.checked)}
            />
            <label htmlFor="agreeTerms" style={{ marginLeft: 8 }}>
              I have read and agree that all top-ups are purely voluntary, non-transferable, non-refundable.
            </label>
          </Stack>

          </Stack>
        </>
      )}

      <StyledModalButtons
        isLoading={isLoading}
        onClose={onClose}
        onSubmit={handleSubmit}
      />
    <ReCAPTCHA
            sitekey={RECAPTCHA_SITE_KEY}
            size="invisible"
            ref={recaptchaRef}
        />
    </>
  )
}

export default CreateTicket
